import { useEffect } from 'react';
import IntegrationsGrid from '../components/IntegrationsGrid';
import CTA from '../components/CTA';

export default function Integrations() {
  useEffect(() => window.scrollTo(0, 0), []);
  return (
    <>
      <section className="section-fade pt-16 pb-4">
        <div className="max-w-4xl mx-auto text-center px-5 lg:px-8">
          <p className="chip mb-4">Integrations</p>
          <h1 className="text-4xl md:text-6xl font-extrabold tracking-tight text-slate-900">
            Works with your favourite tools
          </h1>
          <p className="mt-5 text-slate-600 text-lg">
            Connect ACTIWA with 35+ apps across e-commerce, payments, marketing and automation.
          </p>
        </div>
      </section>
      <IntegrationsGrid />
      <CTA />
    </>
  );
}
